module.exports = __webpack_public_path__ + "static/media/logo-dark-left-menubar.5b455bfa.png";